import styled from "styled-components";
import Search from "../Search";

export const Global = styled.div`
  --color-primary: #002B43;
  --color-secondary: #002B43;
  --color-tertiary: #4EB1E9;
  --color-accent: #f4772d;
  --color-light: #f0f7fc;
  --color-gray: #808080;
  --color-med-gray: #B9B9B9;
  --color-light-gray: #EAEAEA;
  --font-primary: "reader medium";
  font-size: 14px;
  height: 100%;
`;

export const MapContainer = styled.div`
  position: relative;
  margin: 0 auto;
  max-width: 100%;
  height: 100%;
  overflow-y: hidden;
  /* width: 940px; */
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  border: 1px solid #EAEAEA;
  overflow-y: hidden;
`;

export const Container = styled.div`
  position: relative;
  overflow-x: hidden;
  width: 100%;
  height: calc(100% - 51px);
  overflow-y: hidden;
  /* height: 485px; */
`;

export const MapSearch = styled(Search)`
  width: 100%;
  height: 52px;
`;

export const MapViewToggle = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  flex-wrap: wrap;
  row-gap: 10px;
  column-gap: 15px;
  z-index: 3;
  top: 70px;
  width: 100%;

  @media (min-width: 640px){
    width: auto;
    left: 20px;
    top: 70px;
    column-gap: 20px;
  }
`;

export const MapViewButtons = styled.div`
  display: flex;
  justify-content: center;
  margin: 10px;
`;
